//state
import axios from "axios";

export var webSiteState = {
    webSites: [],
    ftp_server_ids:[],
    status_web_site: ""
  };
  
  //getters
  export var webSiteGetters = {
    //funciones para optener informacion del state
    getWebSites: state => state.webSites,
    getFtpServers: state => state.ftp_server_ids
  };
  var user_context = JSON.parse(localStorage.getItem('user_context'));
  var uid = localStorage.getItem("uid");
  var pass = localStorage.getItem("pass");

  //actions
  export var webSiteActions = {
    async getWebSites({ commit }) {
      commit("web_site_request");
      var req_data = {
                        "jsonrpc": "2.0",
                        "method": "call",
                        "params": {
                            service: 'object',
                            method: 'execute',
                            args: [axios.defaults.db, uid, pass, 'apache.domain', 'search_read', [], ["id","name", "ftp_server_id"],
                                0,
                                0,
                                ""
                            ]
                          }
                        };

      await this._vm.$http
        .post("/jsonrpc", req_data)
        .then(res => {
          var getWebSites_data = res.data.result;
          var getWebSites=[];
          //console.log("getWebSites_data ::: ", getWebSites_data);
          if(getWebSites_data.length>0){
              getWebSites=getWebSites_data;
          }

          commit("web_site_success", getWebSites);
          return res;
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async getWebSites12({ commit }) {
      commit("web_site_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.domain", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id","name", ("ftp_server_id",["id","name"])]'
          }
        })
        .then(res => {
          var getWebSites = res.data;
          
          commit("web_site_success", getWebSites);
          return res;
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async getFtpServers({ commit }) {
      commit("web_site_request");
      await this._vm.$http
        .get("/apache/rest_api/ftp.manager", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id","name"]'
          }
        })
        .then(res => {
          var ftp_server_ids = res.data;
          commit("ftp_server_success", ftp_server_ids);
          return res;
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async newWebSite({ commit, state }, webSite) {
      commit("web_site_request");
      var {
        name,
        ftp_server_id
      } = webSite;
      var formData = new FormData();
      var new_web_site = `{
        'name':'${name}',
        'ftp_server_id':'${ftp_server_id.id}'
        }`;
      formData.append("data", new_web_site);
      await this._vm.$http
        .post("/apache/rest_api/apache.domain", formData, {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
          }
        })
        .then(res => {
          if (res.status == 201) {
            webSite.id = res.data.id;
            var webSites = state.webSites;
            webSites.push(webSite);
            commit("web_site_success", webSites);
            return webSites;
          } else {
            commit("web_site_error");
          }
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async editWebSite({ commit, state }, webSite) {
      commit("web_site_request");
      var {
        id,
        name,
        ftp_server_id
      } = webSite;
      var formData = new FormData();
      var new_web_site = `{
        'name':'${name}',
        'ftp_server_id':'${ftp_server_id.id}'
        }`;
      formData.append("data", new_web_site);
      await this._vm.$http
        .put("/apache/rest_api/apache.domain", formData, {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
          },
          params: {
            ids: `[${id}]`
          }
        })
        .then(res => {
          if (res.status == 200) {
            //adsAccount.id = res.data.id;
            var webSites = state.webSites;
            var index;
            for (var i = 0; i < webSites.length; i++) {
              if (webSites[i].id == id) {
                index = i;
                webSites[i] = webSite;
                break;
              }
            }
            webSites.splice(index, 1);
            webSites.splice(index, 0, webSite);
            commit("web_site_success", webSites);
            return webSites;
          } else {
            commit("web_site_error");
          }
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async deleteWebSite({ commit, state }, id) {
      commit("web_site_request");
      await this._vm.$http
      .delete(`/apache/rest_api/apache.domain/${id}`, { 
        headers: {
        "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var webSites = state.webSites
            commit("web_site_success", webSites);
            return webSites;
          } else {
            commit("web_site_error");
          }
        })
        .catch(err => {
          commit("web_site_error");
          return err;
        });
    },
    async deleteWebSiteUtility({ commit, state }, id) {
      commit("web_site_request");
      var index;
      var webSites = state.webSites;
      for (var i = 0; i < webSites.length; i++) {
        if (webSites[i].id == id) {
          index = i;
          break;
        }
      }
      webSites.splice(index, 1);
      commit("web_site_success", webSites);
      return webSites;
    },
  };
  
  //mutations
  
  export var webSiteMutations = {
    web_site_request(state) {
      state.status_web_site = "loading";
    },
    web_site_success(state, payload) {
      state.status_web_site = "success";
      state.webSites = payload;
    },
    ftp_server_success(state, payload) {
      state.status_web_site = "success";
      state.ftp_server_ids = payload;
    },
    web_site_error(state) {
      state.status_web_site = "error";
    }
  };
  